import { render, staticRenderFns } from "./TepGraficaVueltasMundoInternos.vue?vue&type=template&id=00c15a84"
import script from "./TepGraficaVueltasMundoInternos.vue?vue&type=script&lang=js"
export * from "./TepGraficaVueltasMundoInternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports